import { memo } from 'react';

import { twMerge } from 'tailwind-merge';

export interface LoaderProps {
  className?: string;
  legacy?: boolean;
}

export const Loader = memo(function ({ className, legacy = false }: LoaderProps) {
  return legacy ? (
    <div className={twMerge('flex items-center justify-center w-full h-full', className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        width="160px"
        height="20px"
        viewBox="0 0 128 16"
        xmlSpace="preserve"
      >
        <rect x="0" y="0" width="100%" height="100%" fill="none" />
        <path
          fill="#b3e0df"
          fillOpacity="0.42"
          d="M6.4,4.8A3.2,3.2,0,1,1,3.2,8,3.2,3.2,0,0,1,6.4,4.8Zm12.8,0A3.2,3.2,0,1,1,16,8,3.2,3.2,0,0,1,19.2,4.8ZM32,4.8A3.2,3.2,0,1,1,28.8,8,3.2,3.2,0,0,1,32,4.8Zm12.8,0A3.2,3.2,0,1,1,41.6,8,3.2,3.2,0,0,1,44.8,4.8Zm12.8,0A3.2,3.2,0,1,1,54.4,8,3.2,3.2,0,0,1,57.6,4.8Zm12.8,0A3.2,3.2,0,1,1,67.2,8,3.2,3.2,0,0,1,70.4,4.8Zm12.8,0A3.2,3.2,0,1,1,80,8,3.2,3.2,0,0,1,83.2,4.8ZM96,4.8A3.2,3.2,0,1,1,92.8,8,3.2,3.2,0,0,1,96,4.8Zm12.8,0A3.2,3.2,0,1,1,105.6,8,3.2,3.2,0,0,1,108.8,4.8Zm12.8,0A3.2,3.2,0,1,1,118.4,8,3.2,3.2,0,0,1,121.6,4.8Z"
        />
        <g>
          <path
            fill="#4bb4b3"
            fillOpacity="1"
            d="M-42.7,3.84A4.16,4.16,0,0,1-38.54,8a4.16,4.16,0,0,1-4.16,4.16A4.16,4.16,0,0,1-46.86,8,4.16,4.16,0,0,1-42.7,3.84Zm12.8-.64A4.8,4.8,0,0,1-25.1,8a4.8,4.8,0,0,1-4.8,4.8A4.8,4.8,0,0,1-34.7,8,4.8,4.8,0,0,1-29.9,3.2Zm12.8-.64A5.44,5.44,0,0,1-11.66,8a5.44,5.44,0,0,1-5.44,5.44A5.44,5.44,0,0,1-22.54,8,5.44,5.44,0,0,1-17.1,2.56Z"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            values="23 0;36 0;49 0;62 0;74.5 0;87.5 0;100 0;113 0;125.5 0;138.5 0;151.5 0;164.5 0;178 0"
            calcMode="discrete"
            dur="1170ms"
            repeatCount="indefinite"
          />
        </g>
      </svg>
    </div>
  ) : (
    <div className={twMerge('flex items-center justify-center w-full h-full', className)}>
      <div className="relative w-full h-full">
        <div
          style={{
            boxShadow: '0 4px 12px rgba(110, 80, 255, 0.4)',
          }}
          className="bg-v2violet w-[80px] h-[20px] rounded-[20px] absolute top-1/2 left-[calc(50%-40px)] animate-wave"
        />
      </div>
    </div>
  );
});
